module.exports = __webpack_public_path__ + "static/media/tint.f3ec932e.svg";